import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./rootSagas";

const sagaMiddleware = createSagaMiddleware();

const middleware = [sagaMiddleware];

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        // Ignore non-serializable file type
        ignoredActions: [
          "UPLOAD_DETAIL_FILE_REQUEST",
          "UPLOAD_CREATE_APPLICATION_TEMPORARY_FILE_REQUEST",
          "UPLOAD_CREATE_APPLICATION_TEMPORARY_FILE_SUCCESS",
          "DELETE_CREATE_APPLICATION_TEMPORARY_FILE_REQUEST",
          "DELETE_CREATE_APPLICATION_TEMPORARY_FILE_SUCCESS",
          "SET_CREATE_APPLICATION_TRAFFIC_DATA",
          "SET_CREATE_APPLICATION_EXTRA_DATA",
          "REMOVE_SNACKBAR",
          "ENQUEUE_SNACKBAR",
          "DELETE_SNACKBAR"
        ],
        ignoredActionPaths: [
          "attachments",
          "payload.attachments",
          "meta.attachments",
          "createApplication.newApplication.trafficData.tmp",
          "createApplication.newApplication.trafficData.tmp.*",
          "extraAttachments"
        ]
      }
    }).concat(sagaMiddleware)
});

sagaMiddleware.run(rootSaga);

export default store;
